import { useMemo } from "react";
import useIpUs from "@/hooks/api/useIpUs";
import useAdmin from "@/hooks/api/useAdmin";

export default function useCheckUS() {
  const { data: adminData, isLoading: isAdminLoading, isError: isAdminError } = useAdmin();
  const { data, isLoading, isError, mutate } = useIpUs();

  return useMemo(() => {
    if (adminData?.isAdmin) {
      return {
        restricted: false,
        isLoading: false,
        isError: false,
      };
    }
    return {
      restricted: data?.sanctioned,
      isLoading: isLoading || isAdminLoading,
      isError: isError || isAdminError,
      mutate,
    };
  }, [adminData?.isAdmin, data?.sanctioned, isLoading, isAdminLoading, isError, isAdminError, mutate]);
}
